import { COLOR, FONT_SIZE, mq, FONT_WEIGHT } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";

export const DivButtonAffiliate = styled.div`
  margin-bottom: 16px;
`;

export const DivAffiliateButton = styled.div`
  font-weight: ${FONT_WEIGHT.BOLD};
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 16px;
  border-radius: 8px;
  background-color: ${COLOR.GRAY900.code};
  cursor: pointer;

  &:focus-visible {
    outline: 2px solid ${COLOR.YELLOW900.code};
    outline-offset: -2px;
  }
`;

export const ImageLeft = styled.img`
  margin-right: auto;
  ${mq.sp} {
    height: 14px;
  }
`;

export const SpanText = styled.span`
  margin-right: 8px;
  font-size: ${FONT_SIZE.S}px;
  line-height: 24px;
  color: ${COLOR.GRAY50.code};
  ${mq.sp} {
    line-height: 20px;
    font-size: ${FONT_SIZE.XS}px;
  }
`;
